/**
 * InternalNoteEditor — wrapper fino sobre <RichEditor>.
 *
 * FASE 2 / C3 (auditoria 2026-05-21): consolidado em RichEditor. Mantém o
 * nome legado e a API por compat — tests existentes (InternalNoteEditor.test.tsx)
 * continuam funcionando. Internamente delega tudo pro componente canônico.
 *
 * UI-6 (notas internas): features mentions + emoji + markdownHint ON por padrão.
 *
 * Migração futura: callers podem usar <RichEditor> direto pra explicitar o
 * componente canônico. Este wrapper fica como atalho temático.
 */

import { RichEditor } from '@/components/ui';

interface InternalNoteEditorProps {
  value: string;
  onChange: (next: string) => void;
  /** Identifier pra diferenciar editor inline (new) vs edit do mesmo note. */
  testid?: string;
  placeholder?: string;
  rows?: number;
  autoFocus?: boolean;
}

export function InternalNoteEditor({
  value,
  onChange,
  testid = 'internal-note-editor',
  placeholder,
  rows = 3,
  autoFocus = false,
}: InternalNoteEditorProps) {
  return (
    <RichEditor
      value={value}
      onChange={onChange}
      features={{ mentions: true, emoji: true, markdownHint: false }}
      placeholder={placeholder}
      rows={rows}
      autoFocus={autoFocus}
      testid={testid}
    />
  );
}
